import { Select, SelectProps, useSelect } from '@pankod/refine-antd'
import { GetListResponse } from '@pankod/refine-core'
import { QueryObserverResult } from '@tanstack/react-query'
import React from 'react'

const SelectAsync = (
  props: {
    resource: string
    enabledQuery?: boolean
    optionLabel?: string
    optionValue?: string
    optionRender?: (
      data?: QueryObserverResult<GetListResponse<unknown>>['data'],
    ) => SelectProps['options']
  } & SelectProps,
) => {
  const {
    resource,
    enabledQuery,
    optionLabel = 'name',
    optionValue = 'id',
    optionRender,
    ...restProps
  } = props
  const { selectProps, queryResult } = useSelect({
    dataProviderName: 'lms',
    resource,
    queryOptions: { enabled: enabledQuery },
    optionLabel,
    optionValue,
    defaultValueQueryOptions: {
      enabled: false,
    },
    filters: [
      {
        field: 'pageSize',
        operator: 'eq',
        value: -1,
      },
    ],
  })
  const options = optionRender
    ? optionRender(queryResult?.data)
    : [...(selectProps?.options || [])]
  return (
    <Select
      {...restProps}
      options={options}
      loading={queryResult.isFetching}
      onSearch={() => {}}
      filterOption={(input, option) =>
        (option!.label as unknown as string)
          .toLowerCase?.()
          .includes(input.toLowerCase())
      }
    />
  )
}

export default SelectAsync
